module.exports = __webpack_public_path__ + "media/images/palm-ba510a1d70911144c949b7253dde673a.svg";